import React from 'react';
import styles from './styles.module.scss';

import StyledLink from 'components/StyledLink';

import { LOOSE_ITEM_DETAILED_PATH } from 'constants/routeConstants';

import EditableContent from '../EditableContent';

export default function LooseItemCellContent({ row, onEditLooseItem, isEditable }) {
  const { locationLooseItem, itemName, moveQuantity } = row;

  return (
    <EditableContent
      isEditable={isEditable}
      renderDisplayedComponent={() => (
        <div className={styles.looseItem}>
          <StyledLink
            to={`${LOOSE_ITEM_DETAILED_PATH}/${locationLooseItem.looseItem.id}`}
            className={styles.looseItem__link}>
            {itemName || ''}
          </StyledLink>
          <span>{' (' + (moveQuantity || 0) + ') '}</span>
        </div>
      )}
      onEditClick={() => onEditLooseItem(row)}
    />
  );
}
